import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../helpers/Axios";


const wishlists = localStorage.getItem('wishlists');

export const useWishlists = () => {
    return useQuery({
        queryKey: ['wishlists'],
        queryFn: async () => {
            const res = await apiClient.get('/wishlist/wishlists', { params: { products: JSON.parse(wishlists) } })
            return res?.data;
        },
        refetchInterval: 10000
    })

}